<template>
    <div class="o-wrapper">
        <div class="o-grid" :class="cards.length === 0 ? 'o-grid--center' : ''">
            <div v-if="cards.length !== 0 || showPlaceholders" class="o-grid__item u-width-full">
                <div class="cards__wrapper">
                    <div class="cards" id="cards">
                        <content-placeholders v-if="showPlaceholders"></content-placeholders>
                        <post-card-api
                            v-for="card in cards"
                            :key="card.id"
                            :card="card"
                        ></post-card-api>

                        <!-- TODO: BE - I have added front-end lazy loader code in for these
                        but I don't know how you will load it in backend. See js code in _lazyload.js
                        Maybe Vue Lazy Load would be better for this? https://github.com/hilongjw/vue-lazyload -->
                    </div>
                </div>
            </div>
            <div v-else class="o-grid__item u-width-8/12 u-width-full@l" v-if="showEmptyMessage">
                <div v-if="$root.user.username === $root.profile.username" class="c-empty-state">
                    <h4>Ready to Like your first piece of {{$root.community.title}} content?</h4>
                    <p>{{mineNoContentMessage}}</p>
                </div>
                <div v-else class="c-empty-state">
                    <h4>{{theirNoContentTitle}}</h4>
                    <p>As soon as they do it will be listed here.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PostCardApi from "../PostCardApi";
import MasonryStore from "../../configs/masonry-store";
import ContentPlaceholders from "../ContentPlaceholders.vue";

export default {
    components: {
        ContentPlaceholders,
        PostCardApi
    },
    data() {
        return {
            cards: [],
            loading: false,
            masonry: MasonryStore,
            next: true,
            mineNoContentMessage: 'Liking content within communities you are a member allows you to keep track of the things you love, simply select the heart icon within content cards or content pages.',
            page: 1,
            theirNoContentTitle: this.$root.profile.first_name + ' has not yet liked any content within a community',
            showEmptyMessage: false,
            showPlaceholders: false
        }
    },
    created() {
        if (this.$root.user === false || this.$root.user.username !== this.$root.profile.username) {
            this.$router.replace('/u/' + this.$root.profile.username);
            return;
        }
        this.$root.$on('profile-search-liked', (data) => {
            this.fetchData(data);
        });
        this.fetchData();
        if (this.$root.community) {
            this.mineNoContentMessage = 'Liking content within the ' + this.$root.community.title + ' community allows you to keep track of the things you love, simply select the heart icon within ' + this.$root.community.title + ' content cards or content pages.';
            this.theirNoContentTitle = this.$root.profile.first_name + ' has not yet liked any content within the ' + this.$root.community.title + ' community';
        }
    },
    updated() {
        this.$nextTick(() => {
            this.masonry.load();
        });
    },
    mounted() {
        window.addEventListener('scroll', this.loadPostsOnScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.loadPostsOnScroll);
    },
    /*watch: {
        // call again the method if the route changes
        '$route': 'fetchData',
        '$route': 'reinitGrid'
    },*/
    methods: {
        fetchData(search) {
            const cacheKey = this.$simpleStore.localStorageCacheKeys.likes;
            if (!search) {
                const cachedLikes = this.$simpleStore.getWithSlidingExpiry(cacheKey);
                if (cachedLikes != null) {
                    this.cards = cachedLikes;
                    if (this.cards.length === 0) {
                        this.showEmptyMessage = true;
                    }
                    this.masonry.load();
                    return;
                }
            } else {
                this.cards = [];
                this.page = 1;
                this.showEmptyMessage = false;
                window.addEventListener('scroll', this.loadPostsOnScroll);
            }
            let postData = {
                liked: 1,
                page: this.page,
                community_url: this.$root.community.url,
                search: search,
                user_id: this.$root.profile.user_id,
            };
            if (search) {
                this.$root.$emit('bus-profile-search-loading', true);
            }
            this.showPlaceholders = this.page === 1;
            this.loading = true;
            this.$http.post('/api/v1/posts/liked', postData).then(response => {
                this.loading = false;
                if (search) {
                    this.$root.$emit('bus-profile-search-loading', false);
                }
                let totalPages = response.data.total_pages;
                if (this.cards.length === 0) {
                    this.cards = response.data.cards;
                } else {
                    this.cards.push.apply(this.cards, response.data.cards);
                }
                if (this.cards.length === 0) {
                    this.showEmptyMessage = true;
                }
                this.showPlaceholders = false;
                if (!search) {
                    this.$simpleStore.setWithExpiry(cacheKey, this.cards);
                }
                this.next = totalPages > this.page;
                this.page++;
                if (this.page > totalPages) {
                    window.removeEventListener('scroll', this.loadPostsOnScroll);
                }
            }, response => {
                if (search) {
                    this.$root.$emit('bus-profile-search-loading', false);
                }
                if (response.status === 403) {
                    this.$root.$emit('show-private-message');
                }
            });
        },
        loadPostsOnScroll() {
            // only calculate scroll height when not loading and when there are more posts to load
            if (this.loading === false && this.next) {
                let percentageScroll = (Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) / document.documentElement.offsetHeight;
                // load more posts when scrolled 90% of screen height
                if (percentageScroll > 0.9) {
                    this.fetchData();
                }
            }
        }
    }
}
</script>
